import {ADD_LINKS,LOAD_LINKS} from '../actions/actions'

const initialState={
    links:[],
    load:false
}

function reducer(state=initialState,action){
    switch(action.type){
        case ADD_LINKS:
        {   const links=action.payload
            console.log('reducer logs',links)
            return{
                links:{
                    links:links,
                    load:true
                }
            }
        }
        case LOAD_LINKS:
        {
            
        }

    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/reducer.js